import {
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAIL,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  GET_PURCHASES,
  GET_PURCHASES_SUCCESS,
  GET_PURCHASES_FAIL,
  ADD_PURCHASE,
  ADD_PURCHASE_SUCCESS,
  ADD_PURCHASE_FAIL,
  UPDATE_PURCHASE,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_FAIL,
  DELETE_PURCHASE,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_FAIL,
  GET_ARRIVED_PURCHASES,
  GET_ARRIVED_PURCHASES_SUCCESS,
  GET_ARRIVED_PURCHASES_FAIL,
  GET_ARRIVED_PRODUCTS,
  GET_ARRIVED_PRODUCTS_SUCCESS,
  GET_ARRIVED_PRODUCTS_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

// GET ALL PRODUCTS
export const getProducts = () => ({
  type: GET_PRODUCTS,
})
export const getProductsSuccess = products => ({
  type: GET_PRODUCTS_SUCCESS,
  payload: products,
})
export const getProductsFail = error => ({
  type: GET_PRODUCTS_FAIL,
  payload: error,
})
// ADD NEW PRODUCT
export const addProduct = product => ({
  type: ADD_PRODUCT,
  payload: product,
})
export const addProductSuccess = product => ({
  type: ADD_PRODUCT_SUCCESS,
  payload: product,
})
export const addProductFail = error => ({
  type: ADD_PRODUCT_FAIL,
  payload: error,
})
// UPDATE PRODUCT
export const updateProduct = product => ({
  type: UPDATE_PRODUCT,
  payload: product,
})
export const updateProductSuccess = product => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload: product,
})
export const updateProductFail = error => ({
  type: UPDATE_PRODUCT_FAIL,
  payload: error,
})
// DELETE PRODUCT
export const deleteProduct = product => ({
  type: DELETE_PRODUCT,
  payload: product,
})
export const deleteProductSuccess = product => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload: product,
})
export const deleteProductFail = error => ({
  type: DELETE_PRODUCT_FAIL,
  payload: error,
})
// GET ALL PURCHASES
export const getPurchases = () => ({
  type: GET_PURCHASES,
})
export const getPurchasesSuccess = purchases => ({
  type: GET_PURCHASES_SUCCESS,
  payload: purchases,
})
export const getPurchasesFail = error => ({
  type: GET_PURCHASES_FAIL,
  payload: error,
})
// ADD NEW PURCHASE
export const addPurchase = purchase => ({
  type: ADD_PURCHASE,
  payload: purchase,
})
export const addPurchaseSuccess = product => ({
  type: ADD_PURCHASE_SUCCESS,
  payload: product,
})
export const addPurchaseFail = error => ({
  type: ADD_PURCHASE_FAIL,
  payload: error,
})
// UPDATE PURCHASE
export const updatePurchase = purchase => ({
  type: UPDATE_PURCHASE,
  payload: purchase,
})
export const updatePurchaseSuccess = purchase => ({
  type: UPDATE_PURCHASE_SUCCESS,
  payload: purchase,
})
export const updatePurchaseFail = error => ({
  type: UPDATE_PURCHASE_FAIL,
  payload: error,
})
// DELETE PURCHASE
export const deletePurchase = purchase => ({
  type: DELETE_PURCHASE,
  payload: purchase,
})
export const deletePurchaseSuccess = purchase => ({
  type: DELETE_PURCHASE_SUCCESS,
  payload: purchase,
})
export const deletePurchaseFail = error => ({
  type: DELETE_PURCHASE_FAIL,
  payload: error,
})
// GET ARRIVED PURCHASES
export const getArrivedPurchases = (purchases) => ({
  type: GET_ARRIVED_PURCHASES,
  payload: purchases
});
export const getArrivedPurchasesSuccess = (purchases) => ({
  type: GET_ARRIVED_PURCHASES_SUCCESS,
  payload: purchases
});
export const getArrivedPurchasesFail = (error) => ({
  type: GET_ARRIVED_PURCHASES_FAIL,
  payload: error
});
// GET ARRIVED PRODUCTS
export const getArrivedProducts = (products) => ({
  type: GET_ARRIVED_PRODUCTS,
  payload: products
});
export const getArrivedProductsSuccess = (products) => ({
  type: GET_ARRIVED_PRODUCTS_SUCCESS,
  payload: products
});
export const getArrivedProductsFail = (error) => ({
  type: GET_ARRIVED_PRODUCTS_FAIL,
  payload: error
});
// DISPLAY LOADING ICON
export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})